import { init as initApi, search as searchApi } from "../../service/EvaluationImplimentService";

export const INIT_SUCCESS = "EVALUATION_IMPLIMENT_INIT_SUCCESS";
export const INIT_FAIL = "EVALUATION_IMPLIMENT_INIT_FAIL";
export const SEARCH_SUCCESS = "EVALUATION_IMPLIMENT_SEARCH_SUCCESS";
export const SEARCH_FAIL = "EVALUATION_IMPLIMENT_SEARCH_FAIL";
export const EVALUATION_KIND_SELECT = "EVALUATION_IMPLIMENT_EVALUATION_KIND_SELECT";

export const init = () => dispatch => {
  initApi()
    .then(response => {
      if (response.message) {
        alert(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);
        dispatch({
          type: INIT_FAIL,
          payload: { error: "" }
        });
        return;
      }
      dispatch({
        type: INIT_SUCCESS,
        payload: {
          evaluationList: response.evaluationLists,
          evaluationTerms: response.evaluationTerms
        }
      });
    })
    .catch(error => {
      dispatch({
        type: INIT_FAIL,
        payload: { error: error }
      });
    });
};
export const search = params => dispatch => {
  searchApi(params)
    .then(response => {
      if (response.message) {
        dispatch({ type: SEARCH_FAIL, payload: { message: response.message, code: response.messageCode } });
        alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
      } else {
        const rows = response.students.map((student, index) => {
          return {
            id: index,
            serialNumber: student.serialNumber,
            grade: student.grade,
            class: student.classNumber,
            number: student.number,
            name: student.name,
            evaluationImplement: student.evaluationStatus ? "済" : "未"
          };
        });
        dispatch({
          type: SEARCH_SUCCESS,
          payload: {
            rows: rows,
            listId: params.listId,
            termId: params.termId
          }
        });
      }
    })
    .catch(error => {
      dispatch({
        type: SEARCH_FAIL,
        payload: { error: error }
      });
    });
};
export const selectEvaluationKind = params => dispatch => {
  dispatch({ type: EVALUATION_KIND_SELECT, payload: { evaluationKind: params } });
};
